/**
 * Table de routage (react-router v7, mode `createBrowserRouter`).
 *
 * Les chemins sont en français, à l'image du reste de l'interface. Les routes
 * `/admin/*` passent par `AdminLayout`, qui affiche un écran « accès réservé »
 * si le rôle n'est pas `admin`.
 *
 * Elles sont aussi chargées à la demande (`lazy`) : le panneau d'administration
 * embarque `recharts`, qui pèse à lui seul plus que tout le reste du front. Il
 * n'y a aucune raison de l'imposer au téléchargement d'un utilisateur qui vient
 * simplement déployer un artifact.
 */

import { createBrowserRouter } from 'react-router-dom';

import { Layout } from './components/Layout';
import { DeployPage } from './pages/DeployPage';
import { DeploymentProgressPage } from './pages/DeploymentProgressPage';
import { MyAppDetailPage } from './pages/MyAppDetailPage';
import { MyAppsPage } from './pages/MyAppsPage';
import { NotFoundPage } from './pages/NotFoundPage';

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <DeployPage /> },
      { path: 'deploiements/:id', element: <DeploymentProgressPage /> },
      { path: 'mes-applications', element: <MyAppsPage /> },
      { path: 'mes-applications/:id', element: <MyAppDetailPage /> },
      {
        path: 'admin',
        lazy: async () => {
          const module = await import('./pages/admin/AdminLayout');
          return { Component: module.AdminLayout };
        },
        children: [
          {
            index: true,
            lazy: async () => {
              const module = await import('./pages/admin/AdminDashboardPage');
              return { Component: module.AdminDashboardPage };
            },
          },
          {
            path: 'applications',
            lazy: async () => {
              const module = await import('./pages/admin/AdminAppsPage');
              return { Component: module.AdminAppsPage };
            },
          },
          {
            path: 'applications/:id',
            lazy: async () => {
              const module = await import('./pages/admin/AdminAppDetailPage');
              return { Component: module.AdminAppDetailPage };
            },
          },
          {
            path: 'deploiements',
            lazy: async () => {
              const module = await import('./pages/admin/AdminDeploymentsPage');
              return { Component: module.AdminDeploymentsPage };
            },
          },
          {
            path: 'audit',
            lazy: async () => {
              const module = await import('./pages/admin/AdminAuditPage');
              return { Component: module.AdminAuditPage };
            },
          },
          {
            path: 'quotas',
            lazy: async () => {
              const module = await import('./pages/admin/AdminQuotasPage');
              return { Component: module.AdminQuotasPage };
            },
          },
          {
            path: 'systeme',
            lazy: async () => {
              const module = await import('./pages/admin/AdminSystemPage');
              return { Component: module.AdminSystemPage };
            },
          },
        ],
      },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);
